import { createRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { Center, Spinner } from '@chakra-ui/react'
import { authenticatedRoute } from './_authenticated'

const Connections = lazy(() => import('@/pages/friends').then(m => ({ default: m.Connections })))

function ConnectionsWrapper() {
  return (
    <Suspense fallback={<Center h="100vh"><Spinner size="lg" color="purple.500" /></Center>}>
      <Connections />
    </Suspense>
  )
}

export const friendsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/friends',
  component: ConnectionsWrapper,
})

export const friendsUserRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/friends/$userId',
  parseParams: ({ userId }) => ({ userId: Number(userId) }),
  stringifyParams: ({ userId }) => ({ userId: String(userId) }),
  component: ConnectionsWrapper,
})
